// eslint-disable-next-line no-restricted-imports
import { Query_DirectoryController_GetCountries_Items_RiskLevel as CountryRiskLevelTypeApi } from 'api/generated/graphql';
import { CountryRiskLevelType } from 'api/types/entity';

const countryRiskLevelMap: Record<
  CountryRiskLevelTypeApi,
  CountryRiskLevelType
> = {
  [CountryRiskLevelTypeApi.Prohibited]: CountryRiskLevelType.Prohibited,
  [CountryRiskLevelTypeApi.High]: CountryRiskLevelType.High,
  [CountryRiskLevelTypeApi.Medium]: CountryRiskLevelType.Medium,
  [CountryRiskLevelTypeApi.Low]: CountryRiskLevelType.Low,
};

export const parseCountryRiskLevel = (riskLevel: CountryRiskLevelTypeApi) =>
  countryRiskLevelMap[riskLevel];
